// End Point //
// Auth
export const AUTH = `auth`;
export const AUTH_LOGIN = `${AUTH}/login`;
export const AUTH_FORGOT_PASSWORD = `${AUTH}/forgot-password`;
export const AUTH_RESET_PASSWORD = `${AUTH}/reset-password`;

// Pegawai
export const PEGAWAI = `pegawai`;
export const PEGAWAI_LIST = `${PEGAWAI}/list`;
export const PEGAWAI_DETAIL = `${PEGAWAI}/detail`;
export const PEGAWAI_HISTORY_ATTENDANCE = `${PEGAWAI}/history-attendance`;
export const PEGAWAI_SCHEDULES = `${PEGAWAI}/schedules`;
export const PEGAWAI_SUMMARY = `${PEGAWAI}/summary`;
export const PEGAWAI_SAVE = `${PEGAWAI}/save`;
export const PEGAWAI_DIGITAL_LIST = `${PEGAWAI}/digital-data/list`;
export const PEGAWAI_DIGITAL_SAVE = `${PEGAWAI}/digital-data/save`;
export const PEGAWAI_DIGITAL_DELETE = `${PEGAWAI}/digital-data/delete`;
export const PEGAWAI_HISTORY = `${PEGAWAI}/history`;
export const PEGAWAI_HISTORY_LIST = `${PEGAWAI}/history/list`;
export const PEGAWAI_HISTORY_DETAIL = `${PEGAWAI}/history-detail`;
export const PEGAWAI_HISTORY_APPROVE = `${PEGAWAI}/history/approve`;
export const PEGAWAI_HISTORY_DECLINE = `${PEGAWAI}/history/decline`;
export const PEGAWAI_RIWAYAT_LIST = `${PEGAWAI}/riwayat`;
export const PEGAWAI_FAMILY_SAVE = `${PEGAWAI}/family-data/save`;
export const PEGAWAI_FAMILY_DELETE = `${PEGAWAI}/family-data/delete`;
export const PEGAWAI_CHECK_NIP = `${PEGAWAI}/checkNIP`;
export const PEGAWAI_LIST_APPROVED = `${PEGAWAI}/listapproved`;
export const PEGAWAI_APPROVED = `${PEGAWAI}/approved`;

// Unit Kerja
export const PUBLIC = `public`;
export const UNIT_KERJA = `unit-kerja`;
export const UNIT_UTAMA = `${PUBLIC}/unit-utama`;
export const UNIT_KERJA_ALL = `${PUBLIC}/${UNIT_KERJA}/all`;
export const UNIT_KERJA_2 = `${PUBLIC}/${UNIT_KERJA}/${UNIT_KERJA}-2`;
export const UNIT_KERJA_3 = `${PUBLIC}/${UNIT_KERJA}/${UNIT_KERJA}-3`;
export const UNIT_KERJA_4 = `${PUBLIC}/${UNIT_KERJA}/${UNIT_KERJA}-4`;
export const IMAGE_GROUP = `${PUBLIC}/image-group`;
export const DIGITAL_LIST = `${PUBLIC}/digital-list`;
export const USER_SEARCH = `${PUBLIC}/user-search`;
export const PENDIDIKAN_LIST = `${PUBLIC}/pendidikan`;
export const STUDI_LIST = `${PUBLIC}/studi`;
export const GOLONGAN_LIST = `${PUBLIC}/golongan`;
export const ESELON_LIST = `${PUBLIC}/eselon`;
export const JABATAN_LIST = `${PUBLIC}/jabatan`;
export const PANGKAT_LIST = `${PUBLIC}/pangkat`;
export const KELAS_LIST = `${PUBLIC}/jabatan-kelas`;
export const PROVINCE_LIST = `${PUBLIC}/province-search`;
export const CITY_LIST = `${PUBLIC}/city-search`;
export const DISTRICT_LIST = `${PUBLIC}/district-search`;
export const VILLAGE_LIST = `${PUBLIC}/village-search`;
export const JENIS_CATATAN_LIST = `${PUBLIC}/jenis-catatan`;

// Schedule Unit
export const SCHEDULE_UNIT = `schedule-unit`;
export const SCHEDULE_UNIT_LIST = `${SCHEDULE_UNIT}/list`;
export const SCHEDULE_UNIT_DETAIL = `${SCHEDULE_UNIT}/detail`;
export const SCHEDULE_UNIT_SAVE = `${SCHEDULE_UNIT}/save`;
export const SCHEDULE_UNIT_DELETE = `${SCHEDULE_UNIT}/delete`;
export const SCHEDULE_UNIT_LIST_ACTIVE = `${SCHEDULE_UNIT}/listactive`;
export const SCHEDULE_UNIT_LIST_BY_UNIT = `${SCHEDULE_UNIT}/listbyunit`;
export const SCHEDULE_UNIT_SET_DEFAULT = `${SCHEDULE_UNIT}/setdefault`;

// Schedule Group
export const SCHEDULE_GROUP = `schedule-group`;
export const SCHEDULE_GROUP_LIST = `${SCHEDULE_GROUP}/list`;
export const SCHEDULE_GROUP_DETAIL = `${SCHEDULE_GROUP}/detail`;
export const SCHEDULE_GROUP_SAVE = `${SCHEDULE_GROUP}/save`;
export const SCHEDULE_GROUP_DELETE = `${SCHEDULE_GROUP}/delete`;
export const SCHEDULE_GROUP_ARCHIVE = `${SCHEDULE_GROUP}/archive`;
export const SCHEDULE_GROUP_RESTORE = `${SCHEDULE_GROUP}/restore`;

// Message
export const MESSAGE = `message`;
export const MESSAGE_LIST = `${MESSAGE}/list`;
export const MESSAGE_DETAIL = `${MESSAGE}/detail`;
export const MESSAGE_SAVE = `${MESSAGE}/save`;
export const MESSAGE_DELETE = `${MESSAGE}/delete`;

// Message Inbox
export const MESSAGE_INBOX = `${MESSAGE}/inbox`;
export const MESSAGE_INBOX_LIST = `${MESSAGE_INBOX}/list`;
export const MESSAGE_INBOX_DETAIL = `${MESSAGE_INBOX}/detail`;
export const MESSAGE_INBOX_DELETE = `${MESSAGE_INBOX}/delete`;

// User
export const USER = `users`;
export const USER_LIST = `${USER}/list`;
export const USER_LIST_ROLE = `${USER}/roles`;
export const USER_DETAIL = `${USER}/detail`;
export const USER_SAVE = `${USER}/save`;
export const USER_DELETE = `${USER}/delete`;

// Holiday
export const HOLIDAY = `holiday`;
export const HOLIDAY_LIST = `${HOLIDAY}/list`;
export const HOLIDAY_DETAIL = `${HOLIDAY}/detail`;
export const HOLIDAY_SAVE = `${HOLIDAY}/save`;
export const HOLIDAY_DELETE = `${HOLIDAY}/delete`;

// News
export const NEWS = `news`;
export const NEWS_LIST = `${NEWS}/list`;
export const NEWS_DETAIL = `${NEWS}/detail`;
export const NEWS_SAVE = `${NEWS}/save`;
export const NEWS_DELETE = `${NEWS}/delete`;

// Machine
export const MACHINE = `machine`;
export const MACHINE_DATA_NIP = `${MACHINE}/datanip`;
export const MACHINE_DATA_NIP_LIST = `${MACHINE_DATA_NIP}/list`;
export const MACHINE_DATA_NIP_DETAIL = `${MACHINE_DATA_NIP}/detail`;
export const MACHINE_DATA_NIP_SAVE = `${MACHINE_DATA_NIP}/save`;
export const MACHINE_DATA_NIP_DELETE = `${MACHINE_DATA_NIP}/delete`;
export const MACHINE_DEVICE = `${MACHINE}/device`;
export const MACHINE_DEVICE_LIST = `${MACHINE_DEVICE}/list`;
export const MACHINE_DEVICE_DETAIL = `${MACHINE_DEVICE}/detail`;
export const MACHINE_DEVICE_SAVE = `${MACHINE_DEVICE}/save`;
export const MACHINE_DEVICE_DELETE = `${MACHINE_DEVICE}/delete`;

// Attendance
export const ATTENDANCE = `attendance`;
export const ATTENDANCE_LIST = `${ATTENDANCE}/list`;
export const ATTENDANCE_FORCE_UPDATE = `${ATTENDANCE}/force-update`;
export const ATTENDANCE_REQUEST_UPDATE = `${ATTENDANCE}/request-update`;
export const RECAPITULATION_LIST = `${ATTENDANCE}/recapitulation/list`;
export const ATTENDANCE_REQUEST_UPDATE_LIST = `${ATTENDANCE_REQUEST_UPDATE}/list`;
export const ATTENDANCE_REQUEST_UPDATE_BULK = `${ATTENDANCE_REQUEST_UPDATE}-bulk`;
export const ATTENDANCE_REQUEST_UPDATE_STATUS = `${ATTENDANCE_REQUEST_UPDATE}-status`;
export const ATTENDANCE_REQUEST_UPDATE_DELETE = `${ATTENDANCE_REQUEST_UPDATE}-delete`;
export const ATTENDANCE_REQUEST_OFF = `${ATTENDANCE}/request-off`;
export const ATTENDANCE_REQUEST_OFF_LIST = `${ATTENDANCE_REQUEST_OFF}/list`;
export const ATTENDANCE_REQUEST_OFF_BULK = `${ATTENDANCE_REQUEST_OFF}-bulk`;
export const ATTENDANCE_REQUEST_OFF_STATUS = `${ATTENDANCE_REQUEST_OFF}-status`;
export const ATTENDANCE_REQUEST_OFF_DELETE = `${ATTENDANCE_REQUEST_OFF}-delete`;

// Attendance Manual
export const ATTENDANCE_MANUAL = `attendance-manual`;
export const ATTENDANCE_MANUAL_LIST = `${ATTENDANCE_MANUAL}/list`;
export const ATTENDANCE_MANUAL_DETAIL = `${ATTENDANCE_MANUAL}/detail`;
export const ATTENDANCE_MANUAL_SAVE = `${ATTENDANCE_MANUAL}/save`;
export const ATTENDANCE_MANUAL_DELETE = `${ATTENDANCE_MANUAL}/delete`;

// Notification
export const NOTIFICATION = `notification`;
export const NOTIFICATION_LIST = `${NOTIFICATION}/list`;

// Nomenklatur
export const NOMENKLATUR = `nomenklatur`;
export const NOMENKLATUR_LIST = `${NOMENKLATUR}/list`;
export const NOMENKLATUR_UPDATE = `${NOMENKLATUR}/update`;

// Nomenklatur
export const REPORT = `report`;
export const REPORT_DICIPLINE = `${REPORT}/discipline`;
export const REPORT_RECAPITULATION = `${REPORT}/recapitulation`;
export const REPORT_LEAVE = `${REPORT}/leave`;
export const REPORT_LAMPIRAN1G = `${REPORT}/lampiran1g`;

// SKP
export const SKP = `skp`;
export const SKP_LIST = `${SKP}/list`;

// Data Utama
export const DATA_UTAMA = `datautama`;
export const DATA_UTAMA_GOLONGAN = `${DATA_UTAMA}/golongan`;
export const DATA_UTAMA_GOLONGAN_LIST = `${DATA_UTAMA_GOLONGAN}/list`;
export const DATA_UTAMA_GOLONGAN_DETAIL = `${DATA_UTAMA_GOLONGAN}/detail`;
export const DATA_UTAMA_GOLONGAN_SAVE = `${DATA_UTAMA_GOLONGAN}/save`;
export const DATA_UTAMA_GOLONGAN_DELETE = `${DATA_UTAMA_GOLONGAN}/delete`;
export const DATA_UTAMA_KEPANGKATAN = `${DATA_UTAMA}/kepangkatan`;
export const DATA_UTAMA_KEPANGKATAN_LIST = `${DATA_UTAMA_KEPANGKATAN}/list`;
export const DATA_UTAMA_KEPANGKATAN_DETAIL = `${DATA_UTAMA_KEPANGKATAN}/detail`;
export const DATA_UTAMA_KEPANGKATAN_SAVE = `${DATA_UTAMA_KEPANGKATAN}/save`;
export const DATA_UTAMA_KEPANGKATAN_DELETE = `${DATA_UTAMA_KEPANGKATAN}/delete`;
export const DATA_UTAMA_ESELON = `${DATA_UTAMA}/eselon`;
export const DATA_UTAMA_ESELON_LIST = `${DATA_UTAMA_ESELON}/list`;
export const DATA_UTAMA_ESELON_DETAIL = `${DATA_UTAMA_ESELON}/detail`;
export const DATA_UTAMA_ESELON_SAVE = `${DATA_UTAMA_ESELON}/save`;
export const DATA_UTAMA_ESELON_DELETE = `${DATA_UTAMA_ESELON}/delete`;
export const DATA_UTAMA_PENDIDIKAN = `${DATA_UTAMA}/pendidikan`;
export const DATA_UTAMA_PENDIDIKAN_LIST = `${DATA_UTAMA_PENDIDIKAN}/list`;
export const DATA_UTAMA_PENDIDIKAN_DETAIL = `${DATA_UTAMA_PENDIDIKAN}/detail`;
export const DATA_UTAMA_PENDIDIKAN_SAVE = `${DATA_UTAMA_PENDIDIKAN}/save`;
export const DATA_UTAMA_PENDIDIKAN_DELETE = `${DATA_UTAMA_PENDIDIKAN}/delete`;
export const DATA_UTAMA_PENDIDIKAN_LEVEL_ALL = `${DATA_UTAMA_PENDIDIKAN}/listpendidikanlevelall`;
export const DATA_UTAMA_PENDIDIKAN_LEVEL_LIST = `${DATA_UTAMA_PENDIDIKAN}/listpendidikanlevel`;
export const DATA_UTAMA_PENDIDIKAN_LEVEL_DETAIL = `${DATA_UTAMA_PENDIDIKAN}/detailpendidikanlevel`;
export const DATA_UTAMA_PENDIDIKAN_LEVEL_SAVE = `${DATA_UTAMA_PENDIDIKAN}/savependidikanlevel`;
export const DATA_UTAMA_PENDIDIKAN_LEVEL_DELETE = `${DATA_UTAMA_PENDIDIKAN}/deletependidikanlevel`;
export const DATA_UTAMA_PENDIDIKAN_STUDI_LIST = `${DATA_UTAMA_PENDIDIKAN}/liststudi`;
export const DATA_UTAMA_PENDIDIKAN_STUDI_DETAIL = `${DATA_UTAMA_PENDIDIKAN}/detailstudi`;
export const DATA_UTAMA_PENDIDIKAN_STUDI_SAVE = `${DATA_UTAMA_PENDIDIKAN}/savestudi`;
export const DATA_UTAMA_PENDIDIKAN_STUDI_DELETE = `${DATA_UTAMA_PENDIDIKAN}/deletestudi`;
export const DATA_UTAMA_PENDIDIKAN_RUMPUN_LIST = `${DATA_UTAMA_PENDIDIKAN}/listrumpun`;
export const DATA_UTAMA_PENDIDIKAN_RUMPUN_DETAIL = `${DATA_UTAMA_PENDIDIKAN}/detailrumpun`;
export const DATA_UTAMA_PENDIDIKAN_RUMPUN_SAVE = `${DATA_UTAMA_PENDIDIKAN}/saverumpun`;
export const DATA_UTAMA_PENDIDIKAN_RUMPUN_DELETE = `${DATA_UTAMA_PENDIDIKAN}/deleterumpun`;
export const DATA_UTAMA_UNIT_KERJA = `${DATA_UTAMA}/unitkerja`;
export const DATA_UTAMA_UNIT_KERJA_GROUP = `${DATA_UTAMA_UNIT_KERJA}/UnitKerjaGroup`;

// Presensi
export const PRESENSI = `presensi`;
export const PRESENSI_SCHEDULE_PERIOD = `${PRESENSI}/schedule-period`;
export const PRESENSI_SCHEDULE_PERIOD_LIST = `${PRESENSI_SCHEDULE_PERIOD}/list`;
export const PRESENSI_SCHEDULE_PERIOD_DETAIL = `${PRESENSI_SCHEDULE_PERIOD}/detail`;
export const PRESENSI_SCHEDULE_PERIOD_SAVE = `${PRESENSI_SCHEDULE_PERIOD}/save`;
export const PRESENSI_SCHEDULE_PERIOD_DELETE = `${PRESENSI_SCHEDULE_PERIOD}/delete`;
